import { render } from "./AddAnime.vue?vue&type=template&id=2d8e0021&scoped=true"
import script from "./AddAnime.vue?vue&type=script&lang=js"
export * from "./AddAnime.vue?vue&type=script&lang=js"

import "./AddAnime.vue?vue&type=style&index=0&id=2d8e0021&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8e0021"]])

export default __exports__